import { render, staticRenderFns } from "./PromotionFormDialog.vue?vue&type=template&id=b13b03e8&scoped=true"
import script from "./PromotionFormDialog.vue?vue&type=script&lang=js"
export * from "./PromotionFormDialog.vue?vue&type=script&lang=js"
import style0 from "./PromotionFormDialog.vue?vue&type=style&index=0&id=b13b03e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13b03e8",
  null
  
)

export default component.exports